// @flow

import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { If } from '@presentational/If';
import { PrimaryButton } from '@presentational/buttons/PrimaryButton';
import {
  getErrorStatusAndDetailFromErrorObject,
  toastError,
  toastSuccess,
} from '@presentational/notifications/utils';
import { DEFAULT_FE_ERROR_MESSAGE } from '@src/constants';
import { useStarterCommitViolations } from '@src/custom-hooks/useStarterCommitViolations';

import { EstimateContext } from '../../contexts/EstimateContext';
import { getIfQuoteLineIdIsProvided } from '../../common-utils/utils';
import { useUploadDataToSFDCMutation } from '../../service-definitions/estimates';

export const PushToSFDCButton = ({ disabledFromParent }) => {
  const { estimateId } = useParams();
  const estimateData = useContext(EstimateContext);
  const [uploadDataToSFDCFunc] = useUploadDataToSFDCMutation();
  const isQuoteLineIdProvided = getIfQuoteLineIdIsProvided(estimateData?.inputs);
  // The backend rejects the push of a CC Starter Commit outside its package bounds (admins too),
  // so the button is disabled up front; the violations banner explains why.
  const hasStarterCommitViolations = useStarterCommitViolations().length > 0;
  const isPushToSFDCDisabled = disabledFromParent || hasStarterCommitViolations;

  const handlePushToSFDC = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { error } = await uploadDataToSFDCFunc({
      estimateId,
    });
    if (error) {
      const { errorStatus, errorDetail } = getErrorStatusAndDetailFromErrorObject(error);
      let content = DEFAULT_FE_ERROR_MESSAGE;
      if (errorStatus === 404 || errorStatus === 403) {
        content = errorDetail;
      }
      toastError(error, content);
    } else {
      toastSuccess('Successfully uploaded the data to SFDC!!');
    }
  };

  return (
    <If test={isQuoteLineIdProvided}>
      <PrimaryButton
        circular={true}
        compact={true}
        disabled={isPushToSFDCDisabled}
        onClick={handlePushToSFDC}
        size="mini"
        text="Push To SFDC"
      />
    </If>
  );
};
